export default "__VITE_ASSET__B5NX0OUv__"